type Props = {
  isAdmin?: boolean;
  onSubmit?: (payload: any) => void;
  children?: React.ReactNode;
  title?: string;
  subTitle?: string;
  className?: string;
  style?: React.CSSProperties;
};

function NachWrapper({ children, title, subTitle, className, style }: Props) {
  return (
    <div className="container">
      <div className="row" style={{ marginRight: '10px' }}>
        <div
          className={'col-xs-12 col-sm-12 col-md-10 offset-md-1 offset-sm-1 ' + className}
          style={style}
        >
          <div className="mid-container">
            <div className="submission-box">
              <div>
                <h2>
                  {title}
                  {subTitle && (
                    <p style={{ fontSize: '16px', fontWeight: '400', marginTop: '10px' }}>
                      {subTitle}
                    </p>
                  )}
                </h2>
              </div>
              <div className="submission-htmlForm" style={{ marginTop: '30px' }}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NachWrapper;
